// @core/api/endpoints/tenant/update_tenant_sso_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantSSOConfigResponse,
  UpdateTenantSSOConfigRequest,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Update tenant SSO configuration
 * Creates or updates the SSO configuration for the tenant. Supports SAML 2.0 and OIDC protocols. Changes require testing before activation.
 */
export async function UpdateTenantSSOConfig(
  tenant_id: string,
  data: UpdateTenantSSOConfigRequest,
  options?: RequestOptions
): Promise<TenantSSOConfigResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/sso`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.put<TenantSSOConfigResponse>(requestPath, data, requestOptions);
}
